// extracted by mini-css-extract-plugin
export default {"price":"t7-z","onSale":"u7-z","msrpLabelPrice":"v7-z","msrpLabel":"w7-z","originalPrice":"x7-z","percentOff":"y7-z"};